import { action, observable } from "mobx";
import externalInterfaceStore from "stores/ExternalInterfaceStore";

export class LoginManagementStore {

    isLoading(): boolean {
        return externalInterfaceStore.isLoadingSettings;
    }

    @action async load() {
        await this.loadSettings();
    }

    @action async loadSettings() {
        if (externalInterfaceStore.settings || externalInterfaceStore.isLoadingSettings) {
            // We've already loaded the settings -> get out
            return;
        }

        await externalInterfaceStore.loadSettings();
    }
}



// WEBPACK FOOTER //
// ./src/components/loginManagement/LoginManagementStore.ts